/**
 * Constants for the Venture Building and Funding feature
 */
/**
 * Human-readable labels for venture categories
 * Maps category enum values to display names
 */
export const VENTURE_CATEGORIES = {
    real_estate: "Real Estate & Construction",
    hospitality: "Hospitality & Food Service",
    manufacturing: "Manufacturing & Production",
    retail: "Retail & E-commerce",
    service: "Service & Consulting",
    agriculture: "Agriculture & Farming",
};
/**
 * Human-readable labels for venture status
 * Maps status enum values to display names
 */
export const VENTURE_STATUS_LABELS = {
    draft: "Draft",
    live: "Live",
    successful: "Successful",
    failed: "Failed",
    converted: "Converted to Project",
};
/**
 * Minimum pledge amount in currency units
 * Requirement 6.2: Minimum pledge amount validation
 */
export const MIN_PLEDGE_AMOUNT = 1.0;
/**
 * Cache TTL for public venture listings (in seconds)
 * Requirement 15.2: Cache expiration time
 */
export const CACHE_TTL_SECONDS = 300; // 5 minutes
/**
 * Pre-signed URL expiration time (in seconds)
 * Requirement 5.4: Time-limited file access
 */
export const PRESIGNED_URL_EXPIRY = 3600; // 1 hour
